/* Shared product-card dismissal: pointer focus must not pin quick-buy panels. */
(() => {
  const selector = '.product-card-wrapper[data-norgira-grid-card],.norgira-product-card,.norgira-wishlist-card';
  const cardFor = (target) => target instanceof Element ? target.closest(selector) : null;
  const closeOthers = (keep) => document.querySelectorAll(selector).forEach((card) => {
    if (card !== keep) card.classList.remove('is-options-open');
  });
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = cardFor(event.target);
    if (card) closeOthers(card);
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = cardFor(event.target);
    if (card && cardFor(event.relatedTarget) !== card) card.classList.remove('is-options-open');
  }, { passive: true });
  document.addEventListener('pointerdown', (event) => closeOthers(cardFor(event.target)), { passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const card = cardFor(event.target);
    closeOthers(null);
    if (card && document.activeElement instanceof HTMLElement) document.activeElement.blur();
  });
  let scheduled = false;
  document.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(selector).forEach((card) => {
        if (!card.classList.contains('is-options-open')) return;
        const rect = card.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth) {
          card.classList.remove('is-options-open');
        }
      });
    });
  }, { passive: true, capture: true });
})();
